import { memo } from "react";
import { View } from "react-native";
import { ImageCropperProps } from "src/components/ImageCropper/types";

const CutoutOverlay = ({
	inside,
	shape,
}: {
	inside: { width: number; height: number };
	shape: NonNullable<ImageCropperProps["shape"]>;
}) => {
	const innerSize = Math.min(inside.width, inside.height);
	const outerSize = 5 * Math.max(inside.width, inside.height);
	return (
		<View
			style={{
				position: "absolute",
				width: outerSize,
				height: outerSize,
				borderRadius: shape === "Circle" ? outerSize / 2 : 0,
				borderWidth: (outerSize - innerSize) / 2,
				borderColor: "rgba(0, 0, 0, 0.4)",
				borderStyle: "solid",
			}}
		/>
	);
};
export default memo(CutoutOverlay);
